var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36937 7.22705C6.73698 4.86973 10.3103 3.30335 12.1046 2.54343C17.2115 0.387718 18.285 0.0155087 18.9751 0C19.1285 0 19.4659 0.0310176 19.6959 0.217122C19.8799 0.372209 19.926 0.573822 19.9566 0.728909C19.9873 0.883996 20.018 1.20968 19.9873 1.45782C19.7112 4.40447 18.515 11.554 17.9016 14.8418C17.6409 16.2376 17.1348 16.7029 16.644 16.7494C15.5705 16.8424 14.7577 16.036 13.7302 15.3536C12.1046 14.2835 11.1998 13.6166 9.62015 12.562C7.79516 11.3524 8.97604 10.6855 10.0189 9.59988C10.2949 9.32073 15.0031 4.97829 15.0951 4.59057C15.1104 4.54405 15.1104 4.35794 15.0031 4.26489C14.8957 4.17184 14.7424 4.20286 14.6197 4.23387C14.451 4.26489 11.8745 6.00186 6.85967 9.42929C6.12354 9.94107 5.46409 10.1892 4.86598 10.1737C4.20654 10.1582 2.94898 9.80149 1.99815 9.49132C0.847949 9.11911 -0.0722116 8.9175 0.00446848 8.26613C0.0504765 7.92494 0.510557 7.58375 1.36937 7.22705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.b756171fc81a8f45aa0b56032a1e4006.svg";
export { ForwardRef as ReactComponent };